import { useEffect } from "react";
import { useGoogleMaps } from "../../customeHooks/useGoogleMaps";
import { authSliceActions } from "../../redux/features/auth/auth.slice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

export const CoordinatesListener = () => {
  const { deviceCoordinates } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  const { isLoaded } = useGoogleMaps();

  const reverseGeocode = async (lat: number, lng: number) => {
    let city_ = "";
    let state_ = "";
    let country_ = "";
    let address_ = "";
    let place_id_ = "";

    const geocoder = new google.maps.Geocoder();

    const latlng = { lat, lng };

    const a = await geocoder.geocode({ location: latlng });

    const results = a.results;

    if (results && results[0]) {
      results[0].address_components.forEach((component) => {
        if (
          component.types.includes("locality") ||
          component.types.includes("administrative_area_level_2")
        ) {
          city_ = component.long_name;
        }

        if (component.types.includes("administrative_area_level_1")) {
          state_ = component.long_name;
        }

        if (component.types.includes("country")) {
          country_ = component.long_name;
        }
      });

      address_ = results[0].formatted_address;

      place_id_ = results[0].place_id;
    }

    if (!!city_ && !!state_ && !!country_ && !!address_ && !!place_id_) {
      const addressDetails = {
        state: state_,
        address: address_,
        country: country_,
        city: city_,
        destinationGooglePlaceID: place_id_,
      };

      dispatch(authSliceActions.updateDeviceAddressDetails(addressDetails));
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        dispatch(
          authSliceActions.updateDeviceCoordinates({
            lat: latitude,
            lng: longitude,
          }),
        );
      },
      (error) => {
        console.error("Error getting location:", error);
      },
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLoaded && !!deviceCoordinates?.lat && !!deviceCoordinates.lng) {
      reverseGeocode(deviceCoordinates.lat, deviceCoordinates.lng);
    }
    // eslint-disable-next-line
  }, [deviceCoordinates, isLoaded]);

  return undefined;
};
